import API from '../../api/admin'

const state = {
  dashboardTab: null,
  selfHelpGroups: [],
  volunteers: [],
  users: [],
}

const getters = {

}

const mutations = {
  setDashboardTab (state, payload) {
    state.dashboardTab = payload;
  },
  setSelfHelpGroups (state, payload) {
    state.selfHelpGroups = payload;
  },
  setVolunteers (state, payload) {
    state.volunteers = payload;
  },
  setUsers (state, payload) {
    state.users = payload;
  }
}

const actions = {
  getSelfHelpGroups ({commit}) {
    return API.getSelfHelpGroups()
      .then(response => {
        commit('setSelfHelpGroups', response.data.data)
      })
  },
  getVolunteers ({commit}) {
    return API.getVolunteers()
      .then(response => {
        commit('setVolunteers', response.data.data)
      })
  },
  getUsers ({commit}) {
    return API.getUsers()
      .then(response => {
        commit('setUsers', response.data.data)
      })
  }
}

export default {state, getters, mutations, actions};
